import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const SideBarWrapper = styled.aside`
  transition: all 0.5s;
  background-color: #e6e6e6;
  z-index: 199;
  width: 208px;
  min-width: 208px;
  border-top-right-radius: 20px;
  position: static;
  min-height: calc(100dvh - 56px);
  overflow-y: auto;

  &.open {
    @media (max-width: 767px) {
      position: fixed;
      height: calc(100dvh - 56px);
      top: 56px;
      left: 0;
      right: 0;
      width: 50%;
      max-height: none;
    }
  }
  &.close {
    @media (max-width: 767px) {
      position: fixed;
      height: 100%;
      &:lang(ar) {
        left: 105%;
      }
      &:lang(en) {
        right: 105%;
      }
    }
  }
  @media print {
    display: none;
  }
  .org-name {
    background-color: #f1f1f1;
    border-radius: 8px;
    padding: 6px 6px 7px 12px;
    font-size: 14px;
    margin: 0 8px;
    cursor: pointer;

    .mantine-Avatar-root {
      width: 20px;
      min-width: 20px;
      height: 20px;
      border-radius: 4px;
      .mantine-Avatar-placeholder {
        font-size: 7px;
        width: 20px;
        height: 20px;
        font-family: ${theme.fonts.Medium};
        color: #6d6d88;
        background-color: #dedede;
      }
    }
    p {
      text-overflow: ellipsis;
      overflow: hidden;
      width: 118px;
      height: 1.2em;
      white-space: nowrap;
    }
    svg {
      width: 10px;
      height: 7px;
    }
  }
  .container-select {
    position: absolute;
    top: 74px;
    background-color: white;
    padding: 8px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 176px;
    border-radius: 8px;
    z-index: 4;
    p {
      font-size: 14px;
      cursor: pointer;
    }
    .active-tenant {
      background-color: #ebebeb;
      border-radius: 4px;
      padding: 3px;
    }
  }
`;
export const SectionsWrapper = styled.aside`
  padding: 0 16px 32px;
  background-color: #e6e6e6;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top-right-radius: 20px;
`;

export const SideBarInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(${theme.space_size} * 2);
  padding: 0px 8px;
  gap: 16px;
  .LogoWrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
  }
  button {
    display: block;
    background-color: ${theme.colours.AntiFlashWhite};
    padding: 10px;
    border-radius: 12px;
    width: 40px;
    height: 40px;
    &:hover {
      background-color: ${theme.colours.AntiFlashWhite};
    }
    @media (min-width: 768px) {
      display: none;
    }
  }
`;

export const SideBarLinks = styled.div`
  position: relative;
  top: 41px;

  .line {
    border-bottom: 1px solid ${theme.colours.Cultured};
    padding-bottom: 24px;
  }
`;
export const NavItem = styled.div<{ activeLink: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  background-color: ${(props) => (props.activeLink ? '#FAFAFA' : '#E6E6E6')};
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 13px;
  height: 38px;

  .count {
    font-family: ${theme.fonts.Medium};
    background-color: ${theme.colours.AntiFlashWhite};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    position: relative;
    &::before {
      position: absolute;
      content: '';
      width: 5px;
      height: 5px;
      background-color: ${theme.colours.PermanentGeraniumLake};
      border-radius: 50%;
      left: 15px;
      z-index: 9;
      top: 0;
    }
  }
  a {
    gap: 12px;
    text-decoration: none;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-top: -1px;
    div {
      display: flex;
      align-items: center;
    }
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.black};
      font-weight: 400;
      white-space: nowrap;
      line-height: 22px;
    }
  }
`;

export const SideBarHelpersActionWrapper = styled.div`
  padding: 0 6px;

  .langWrapper {
    div {
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: ${theme.space_size};
      img {
        width: 20px;
        height: 20px;
        object-fit: cover;
        border-radius: 4px;
      }
      p {
        font-size: 14px;
        font-family: ${theme.fonts.Medium};
        text-transform: capitalize;
      }
    }
  }
  .HelpWrapper {
    color: ${theme.colours.silverChalice};
    font-family: ${theme.fonts.Regular};
    font-size: 13px;
    cursor: pointer;
  }
  .settings {
    cursor: pointer;
    font-size: 14px;
    color: #000000;
    font-weight: 400;
  }
`;

export const UpgradeButton = styled(NavItem)`
  background-color: #f5f5f5 !important;
  border: 1px solid ${theme.colours.gray};
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 4px;
  margin-top: 48px;
  border-radius: 8px;
  height: auto;
  min-height: 38px;
  padding: 8px 6px;

  a {
    gap: 12px;
    text-decoration: none;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-top: -1px;
    div {
      display: flex;
      align-items: center;
      color: ${theme.colours.black};
      svg {
        color: ${theme.colours.black};
      }
    }
    .button-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      p {
        font-family: ${theme.fonts.Medium};
        font-size: 14px;
        color: ${theme.colours.black};
        font-weight: 400;
        white-space: nowrap;
        line-height: 18px;
        margin: 0;
      }
    }
  }

  &:hover {
    background-color: #EBEBEB !important;
    border-color: #000000;
  }

  &:active {
    background-color: #E0E0E0 !important;
  }
`;

export const HelperText = styled.span`
  font-family: ${theme.fonts.Regular};
  font-size: 11px;
  color: ${theme.colours.blackText};
  line-height: 12px;
  margin: 0;
  padding: 0;
  white-space: nowrap;
`;
